import { render, staticRenderFns } from "./maindoc.vue?vue&type=template&id=1300335d&scoped=true&"
import script from "./maindoc.vue?vue&type=script&lang=js&"
export * from "./maindoc.vue?vue&type=script&lang=js&"
import style0 from "./maindoc.vue?vue&type=style&index=0&id=1300335d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300335d",
  null
  
)

export default component.exports